export class FeedbackDeliveryNotFoundError extends Error { }
